export default __webpack_public_path__ + "static/media/sensotrend_uploader_location.5d99d475.png";